import styled from "@emotion/styled";
import { UiTheme } from "@nykaa/payment-ui/src/@types";


export const DiscountInfoStripWrapper = styled.div`
  position: sticky;
  padding: 6px 0;
  left: 0;
  top: 52px;
  width: 100%;
  z-index: 2;
  margin-top: -6px;
  background: ${({ theme }: UiTheme) => theme?.colors?.positive10};
  border: none;
  border-radius: 0;
  text-align: center;
`;
